import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { _noop } from '@client/new/helpers/general';

export const DeleteContentModal = (p: {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}) => {
  return (
    <Modal
      stretchCta
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Delete?"
      centerContent
      modalClassName="w-full md:max-w-[452px]"
      primaryCta={{
        caption: 'Yes, delete',
        onClick: () => p.onSubmit(),
      }}
      secondaryCta={{
        caption: 'Cancel',
        onClick: p.onClose,
      }}
    >
      <Typography variant="body" fontWeight="normal">
        This action will <strong>delete</strong> the Content Item completely.
        This is irreversible action. Are you sure?
      </Typography>
    </Modal>
  );
};

export const ArchiveContentModal = (p: {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Archiving?"
      centerContent
      stretchCta
      modalClassName="w-full md:max-w-[452px]"
      primaryCta={{
        caption: 'Yes, archive',
        onClick: () => p.onSubmit(),
      }}
      secondaryCta={{
        caption: 'Cancel',
        onClick: p.onClose,
      }}
    >
      <Typography variant="body" fontWeight="normal">
        Archiving this Content Item will hide it from your channel and any
        offering it was added. Customers won’t see it or be able to purchase it.
        However, customers who have already bought it will still have access.
      </Typography>
    </Modal>
  );
};

export const UnarchiveContentModal = (p: {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Unarchiving?"
      centerContent
      stretchCta
      modalClassName="w-full md:max-w-[452px]"
      primaryCta={{
        caption: 'Yes, unarchive',
        onClick: () => p.onSubmit(),
      }}
      secondaryCta={{
        caption: 'Cancel',
        onClick: p.onClose,
      }}
    >
      <Typography variant="body" fontWeight="normal">
        Unarchiving will restore the item’s previous access method. It may
        become visible to users depending on the offer’s status.
      </Typography>
    </Modal>
  );
};

export const SellAsSubscriptionModal = (p: {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Make your content visible"
      stretchCta
      modalClassName="w-full md:max-w-[452px]"
      primaryCta={{
        caption: 'Yes, proceed',
        onClick: () => p.onSubmit(),
      }}
      secondaryCta={{
        caption: 'Go back',
        onClick: p.onClose,
      }}
    >
      <Typography variant="body" fontWeight="normal">
        Extras that are part of any published offer or your live subscription
        will be visible to your users. Users without access will be asked to pay
        for access.
      </Typography>
    </Modal>
  );
};

export const SellAsAnyPurchaseModal = (p: {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Change to any purchase access"
      stretchCta
      modalClassName="w-full md:max-w-[452px]"
      primaryCta={{
        caption: 'Yes, proceed',
        onClick: () => p.onSubmit(),
      }}
      secondaryCta={{
        caption: 'Go back',
        onClick: p.onClose,
      }}
    >
      <Typography variant="body" fontWeight="normal">
        This will change the content access method to "any purchase". The
        content will be available to all users with an active subscription and
        will require manual publishing.
      </Typography>
    </Modal>
  );
};

export const SellOnlyInBundleModal = (p: {
  isOpen: boolean;
  onSubmit: () => void;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={p.isOpen}
      onClose={p.onClose}
      title="Remove from subscription"
      stretchCta
      modalClassName="w-full md:max-w-[452px]"
      primaryCta={{
        caption: 'Yes, proceed',
        onClick: () => p.onSubmit(),
      }}
      secondaryCta={{
        caption: 'Go back',
        onClick: p.onClose,
      }}
    >
      <Typography variant="body" fontWeight="normal">
        This will remove the content from your subscription and keep it
        available only within offers. The content will no longer be accessible
        via subscription alone.
      </Typography>
    </Modal>
  );
};
